import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';

const DesktopMenu = ({ auth, logout }) => {
    return (
        <div className="userMenuDesktop d-flex justify-content-between align-items-center mr-3">
            {auth.isAuthenticated && (
                <div className="header-nav d-flex justify-content-between align-items-center">
                    <NavLink to="/products">Products</NavLink>
                    <NavLink to="/organizations">Organizations</NavLink>
                    <NavLink to="/combined-users">Users</NavLink>
                    <NavLink to="/nudge-emails">Nudge Emails</NavLink>
                    <NavLink to="/fb-accounts">FB Accounts</NavLink>
                    <Link to="/" onClick={logout} style={{ fontWeight: '700' }}>
                        Logout
                    </Link>
                </div>
            )}
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { logout }
)(DesktopMenu);
